module.exports = __webpack_public_path__ + "img/undo.335e4907.svg";